import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import '../../pages/admin/sms-management.css';

const fmt = (n) => new Intl.NumberFormat('ru-RU').format(n ?? 0);

export default function TopUpSmsModal({ open, onClose, schoolId, api, tariffData }) {
    const { t } = useTranslation(['sms', 'schoolSettings', 'common']);
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState('');

    const tariff = tariffData?.tariff;
    const packages = tariff?.packages || [];

    async function purchase(count) {
        if (!schoolId || busy) return;
        setBusy(true);
        setMsg('');
        try {
            const res = await api.post('/school/sms/purchase', { packageSize: count }, { params: { schoolId } });
            if (res.data?.paymentUrl) {
                window.location.href = res.data.paymentUrl;
                return;
            }
            setMsg(t('common:error'));
        } catch (e) {
            setMsg(e.response?.data?.message || t('common:error'));
        } finally {
            setBusy(false);
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('sms:topUpModalTitle')}
            className="top-up-sms-modal"
        >
            <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.55, margin: '0 0 20px' }}>
                {t('sms:topUpModalSubtitle')}
            </p>

            {!tariff ? (
                <p style={{ color: '#64748b' }}>{t('sms:notAvailable')}</p>
            ) : packages.length === 0 ? (
                <p style={{ color: '#64748b' }}>{t('sms:notConfiguredPlatform')}</p>
            ) : (
                <div className="sms-packages" style={{ marginBottom: 16 }}>
                    {packages.map((pkg) => (
                        <div key={pkg.count} className="sms-package-card" style={{ cursor: busy ? 'wait' : 'default' }}>
                            <div className="sms-package-count">{t('schoolSettings:smsPackage', { count: pkg.count, price: fmt(pkg.price) })}</div>
                            <div className="sms-package-unit" style={{ marginBottom: 10 }}>
                                {(pkg.pricePerSms ?? 0).toFixed(2)} {tariff.currency} {t('sms:pricePerSms')}
                            </div>
                            <button
                                type="button"
                                disabled={busy}
                                onClick={() => purchase(pkg.count)}
                                style={{
                                    width: '100%',
                                    padding: '10px 14px',
                                    borderRadius: 8,
                                    border: 'none',
                                    background: '#EB3333',
                                    color: '#fff',
                                    fontWeight: 600,
                                    cursor: busy ? 'wait' : 'pointer',
                                }}
                            >
                                {busy ? t('common:loading') : t('schoolSettings:smsPay')}
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {msg ? <p style={{ color: '#b91c1c', marginBottom: 12 }}>{msg}</p> : null}

            <p style={{ fontSize: 12, color: '#94a3b8', lineHeight: 1.5, margin: 0 }}>
                {t('sms:topUpModalNote')}
            </p>
        </Modal>
    );
}
